import React from 'react';

/** Small-caps section heading for the single-page user panel. */
export default function SectionHead({ id, title, children }) {
  return (
    <div className="us-sec">
      <h3 id={id}>{title}</h3>
      {children}
    </div>
  );
}
